<script>
import * as Elements from "./elements"
import { payload, errors } from "@local/store/engine"

export let element

const operations = {
  equals: (a, b) => {
    if (Array.isArray(a) && Array.isArray(b)) {
      return JSON.stringify(a) === JSON.stringify(b)
    }
    return a === b
  },
  notEquals: (a, b) => {
    if (Array.isArray(a) && Array.isArray(b)) {
      return JSON.stringify(a) !== JSON.stringify(b)
    }
    return a !== b
  },
  gte: (a, b) => a >= b,
  lengthGt: (a, b) => (a || []).length > b,
  lengthLte: (a, b) => (a || []).length <= b,
  includes: (a, b) => (a || []).includes(b),
  notIncludes: (a, b) => !(a || []).includes(b),
  isDefined: (a, _b) => a !== undefined && a !== null,
  notDefined: (a, _b) => a === undefined || a === null,
  daysFuture: (a, b) => differenceInDays(a, new Date()) >= b,
  daysPast: (a, b) => differenceInDays(new Date(), a) >= b,
  scheduleFuture: (a, b) => {
    if (typeof a === "string" && a.includes("~")) {
      a = a.split("~")[0]
    }
    return differenceInDays(new Date(a), new Date()) >= b
  },
  minutesFuture: (a, b) => {
    if (b === null) return false
    return differenceInMinutes(new Date(a), new Date()) >= b
  },
}

$: component = Elements[element.type]
function checkDependsOn(element, payload = {}) {
  if (!element?.props?.dependsOn) return true
  for (let dependency of element?.props?.dependsOn) {
    const { propKey, operator, value } = dependency
    const operation = operations[operator]
    if (!operation(payload[propKey], value)) return false
  }
  return true
}
</script>

{#if element}
  {#if checkDependsOn(element, $payload)}
    <svelte:component
      this="{component}"
      {...element?.props}
      allErrors="{$errors}"
      errors="{element?.props?.name && $errors?.[element?.props?.name]}"
      bind:payload="{$payload}"
      bind:value="{$payload[element?.props?.name]}"
    />
  {/if}
{/if}
